import React from 'react';

import Button from 'components/Button';
import ROUTES from 'config/routes';


const CallToAction = props => {
  return (
    <div className="form-section">
      <div className="text-center">
        <div className="field-wrap">
          <p className="form-text form-text--dark">Wish to post an article in the Forum?</p>
        </div>
        <div className="text-center">
          <div className="field-wrap">
            <Button bgColor="green" to={ROUTES.createForumApplication}>Post</Button></div>
        </div>
      </div>
    </div>
  );
}

export default CallToAction;